<template>
  <div class="pwc-register-form">
    <navigation />
    <pwc-container class="pwc-app-container">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-if="cInnerIntro" class="pwc-form-title" style="text-align:left;margin-bottom:12px;" v-html="cInnerIntro" />
      <div v-else class="pwc-form-title">
        <span>{{ cTitle }}</span>
      </div>
      <v-form ref="form" class="pwc-form-data">
        <v-text-field v-model="name" label="姓名" :disabled="cAnchorApplySubmited" :rules="[rules.required]" :validate-on-blur="true" />
        <v-select v-model="age" :items="lookups.ageRange" item-text="name" item-value="id" label="年龄" :disabled="cAnchorApplySubmited" :rules="[rules.validSelect]" :validate-on-blur="true" />
        <!-- <v-select
    v-if="cEventType == 1"
    v-model="yearsOfWork"
    :items="lookups.workYearRange"
    item-text="name"
    :return-object="false"
    item-value="id"
    label="工作年限"
    :disabled="cAnchorApplySubmited"
    :rules="[rules.required]"
    :validate-on-blur="true"
  /> -->
       <v-menu
        v-if="(cShowF10 || cShowF11 ||cShowF12 || cShowF13 || cShowF14 || cShowF15 ||  cShowF16)" 
        ref="menu"
        v-model="showDate"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field  v-model="birthDay"  label="生日"  prepend-icon="mdi-calendar"  readonly  v-bind="attrs"  v-on="on" :disabled="cAnchorApplySubmited" :validate-on-blur="true"></v-text-field>
        </template>
        <v-date-picker  v-model="birthDay"  no-title  scrollable  @input="showDate = false" ></v-date-picker>
      </v-menu>
    <v-text-field v-model="email" label="邮箱" :disabled="cAnchorApplySubmited" :rules="[rules.email, rules.required]" :validate-on-blur="true" />
        <!-- <v-text-field
    v-if="cEventType == 1"
    v-model="company"
    label="公司"
    :disabled="cAnchorApplySubmited"
    :rules="[rules.required]"
    :validate-on-blur="true"
  />
  <v-text-field
    v-if="cEventType == 1"
    v-model="title"
    label="职位"
    :disabled="cAnchorApplySubmited"
    :rules="[rules.required]"
    :validate-on-blur="true"
  /> -->
        <v-text-field v-if="cEventType == 0" v-model="eduInstitution" label="学校" :disabled="cAnchorApplySubmited" :rules="[rules.required]" :validate-on-blur="true" />
        <v-select v-if="cEventType == 0" ref="grade" v-model="grade" :items="lookups.anchorStudentGrades" item-text="name" item-value="id" label="年级" :disabled="cAnchorApplySubmited" :rules="[rules.required]" :validate-on-blur="true" />
        <v-text-field v-if="cEventType == 0" v-model="major" label="专业" :disabled="cAnchorApplySubmited" :rules="[rules.required]" :validate-on-blur="true" />

        <!-- anchor apply -->
        <v-select v-if="cClassLookup.classes.length > 1 && (cShowF13||cShowF12 || cShowF14 || cShowF16)" v-model="classId" :items="cClassLookup.classes" item-text="name" item-value="id" label="您希望参加哪一期的课程?" :disabled="cAnchorApplySubmited" :rules="[rules.validSelect]" :validate-on-blur="true" />
        <!-- <v-select v-if="cClassLookup.classes.length > 1 && (cShowF13||cShowF12 || cShowF14)" v-model="cityId" :items="applyLookups.cities" item-text="name" item-value="id" label="您希望在以下哪个城市上课?" :disabled="cAnchorApplySubmited" :rules="[rules.required]" :validate-on-blur="true" /> -->
        <!-- <v-select
    v-model="registerFromCityId"
    :items="applyLookups.registerFromCities"
    item-text="name"
    item-value="id"
    label="您是在以下哪个城市报名该项目的?"
    :disabled="cAnchorApplySubmited"
    :rules="[rules.required]"
    :validate-on-blur="true"
  /> -->
        <v-text-field v-if="(cShowF13 || cShowF14) && cShowOtherCityField" v-model="cityOtherName" label="您希望上课的城市?" :disabled="cAnchorApplySubmited" />
        <!-- <v-select
          v-model="overseaRegionIds"
          :items="applyLookups.overseaRegions"
          item-text="name"
          item-value="id"
          multiple
          label="关于海外商务体验，您对以下哪些地区感兴趣?"
          :disabled="cAnchorApplySubmited"
          :rules="[rules.validSelect]"
          :validate-on-blur="true"
        /> -->
        <v-text-field v-if="cShowF11 || cShowF13 || cShowF14" v-model="gpa" type="number" label="最高学位的GPA(GPA的范围是0-999.99)" :disabled="cAnchorApplySubmited" :rules="[rules.required]" :validate-on-blur="true" />
        <v-textarea v-if="cShowF13 || cShowF14" v-model="activitiesOnCampus" style="margin-top:10px" box label="您是否有课外活动的经历（校内活动）？" auto-grow flat :disabled="cAnchorApplySubmited" :validate-on-blur="true" :rules="[rules.required]" />

        <v-textarea v-if="cShowF13 || cShowF14" v-model="activitiesOffCampus" box label="您是否有课外活动的经历（校外活动）？" auto-grow flat :disabled="cAnchorApplySubmited" :validate-on-blur="true" :rules="[rules.required]" />
        <!-- <v-select v-if="cShowF14" v-model="fcpId" :items="usroadshowfcps.fcps" item-text="name" item-value="id" label="You Plus 团队联系人" :disabled="cAnchorApplySubmited" :validate-on-blur="true" /> -->
        <v-select
          v-if="cShowF15 || cShowF16"
          v-model="parentSupportReason"
          :items="applyLookups.parentSupportReasons"
          item-text="name"
          item-value="id"
          multiple
          label="父母支持你参与Anchor项目的原因是什么? （可多选）"
          :disabled="cAnchorApplySubmited"
          :rules="[rules.validSelect]"
          :validate-on-blur="true"
        />
        <v-textarea v-if="cShowF15 || cShowF16" v-model="familyExpect" box placeholder="家庭对你职业规划、职业发展的期待是什么？ 请阐述家人做了哪些事或将做哪些事，以帮助你提高个人职业竞争力。" :disabled="cAnchorApplySubmited" :validate-on-blur="true" />

        <v-select v-if="(applyLookups.refereetype || []).length > 1" v-model="refereeTypeId" :items="applyLookups.refereetype" item-text="name" item-value="id" label="推荐人类型" :disabled="cAnchorApplySubmited" :validate-on-blur="true" />
        <v-text-field v-if="refereeTypeId" v-model="refereeName" label="推荐人" :disabled="cAnchorApplySubmited" :validate-on-blur="true" />
      </v-form>
      <v-layout row class="pwc-form-action" justify-space-around>
        <v-flex v-if="!cAnchorApplySubmited" xs5>
          <v-btn color="#d04a02" depressed outline block @click="handleSaveAnchorApply">保存</v-btn>
        </v-flex>
        <v-flex xs5>
          <v-btn :disabled="cAnchorApplySubmited" color="#d04a02" depressed outline block @click="handleDesktopSubmit">{{ cAnchorApplySubmited?'已提交':'提交' }}</v-btn>
        </v-flex>
      </v-layout>
    </pwc-container>

    <!-- dialog -->
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-text>
          {{ dialogText }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn v-if="dialogCancel" color="#d04a02" flat="flat" @click="handleDialogCancel"> 取消 </v-btn>
          <v-btn color="#d04a02" flat="flat" @click="handleDialogConfirm"> 确定 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <pwc-term :show.sync="showTermDialog" :term="term" :confirm="handleConfirm" />
  </div>
</template>

<script>
import {
  validRequired,
  validEmail,
  validRequiredSelect,
  gpaCode
} from '@/util/validation'
import { next } from '@/mixin/index'
import { logic } from '../common/mixin/logic'
import Navigation from '@/views/layout/desktop/PwcNav'
import PwcContainer from '@/views/layout/desktop/PwcContainer'
import PwcTerm from '@/components/PwcTerm/desktop'
import { VDatePicker,} from 'vuetify/lib'
export default {
  components: {
    Navigation,
    PwcContainer,
    PwcTerm,
    VDatePicker
  },
  mixins: [next, logic],
  data() {
    return {
      dialog: false,
      dialogCancel: false,
      dialogText: '',
      rules: {
        required: validRequired,
        email: validEmail,
        validSelect: validRequiredSelect,
        gpa: gpaCode
      },
      showOnCampusMenu: false,
      showOffCampusMenu: false,
      onCampusDates: [],
      offCampusDates: []
    }
  },
  computed: {
    cEventType() {
      return Number(this.programmeType)
    }
  },
  watch: {
    onCampusDates(n) {
      this.activitiesOnCampus2 = this.handleFormatDate(n)
    },
    offCampusDates(n) {
      this.activitiesOffCampus2 = this.handleFormatDate(n)
    }
  },
  methods: {
    handleCheck() {
      if (!this.name || validEmail(this.email) !== true) {
        // this.disableRegister = true
      } else {
        // this.disableRegister = false
      }
    },
    handleDialogMessage(message, withCancel = false) {
      if (message) {
        this.dialogText = message
        this.dialog = true
        this.dialogCancel = withCancel
      }
    },
    handleDialogCancel() {
      this.dialog = false
    },
    handleDialogConfirm() {
      this.dialog = false
      if (this.dialogCancel) {
        this.handleSubmitAnchorApply()
      }
      this.dialogCancel = false
    },
    handleDesktopSubmit() {
      const validate = this.$refs.form.validate()
      if (validate) {
        this.handleDialogMessage('提交后不可修改, 确认提交 ？', true)
      }
    },
    handleSelectOnCampusDate() {
      if (this.onCampusDates.length > 2) {
        this.onCampusDates.splice(0, 2)
      }
      this.onCampusDates.sort()
    },
    handleSelectOffCampusDate() {
      if (this.offCampusDates.length > 2) {
        this.offCampusDates.splice(0, 2)
      }
      this.offCampusDates.sort()
    },
    handleFormatDate(date) {
      if (date.length === 0) return ''

      const [startYear, startMonth] = date[0].split('-')
      if (date.length === 1) {
        return `${startYear}年${startMonth}月 - `
      }

      const [endYear, endMonth] = date[1].split('-')
      return `${startYear}年${startMonth}月 - ${endYear}年${endMonth}`
    },
    handleParseDate(date) {
      if (!date) return []
      const info = date.split('-')
      if (info.length !== 2) {
        return []
      }
      const start = info[0].match(/\d+/g)
      const end = info[1].match(/\d+/g)

      const [startMonth, startYear] = [start[1], start[0]]
      const [endMonth, endYear] = [end[1], end[0]]

      return [
        `${startYear}-${startMonth.padStart(2, '0')}`,
        `${endYear}-${endMonth.padStart(2, '0')}`
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-register-form {
  // padding-bottom: 64px;
  background-image: url("../../../assets/register-form-bg.jpg");
  background-attachment: fixed;
  .pwc-app-container {
    margin-bottom: 0;
    margin-top: 0;
    padding-top: 36px;
    padding-bottom: 36px;
  }

  .pwc-form-title,
  .pwc-form-data,
  .pwc-form-action {
    margin: auto;
    max-width: 640px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #fff;
    padding-top: 24px;
  }

  .pwc-form-title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    line-height: 64px;
  }

  // .pwc-form-data {
  //     // margin-bottom: 24px;
  // }

  .pwc-form-action {
    // margin-top: 12px;
    text-align: center;
    padding-bottom: 32px;
  }
}
</style>

<style lang="scss">
.pwc-register-form {
  .theme--light.v-text-field.v-input--is-disabled
    > .v-input__control
    > .v-input__slot:before {
    border-image: none;
  }
  .v-text-field--box > .v-input__control > .v-input__slot {
    border-radius: 0;
  }
}
.v-date-picker-table .v-btn.v-btn--active {
   color: red;
}
.v-picker__title{
  color: rgb(0,0,0)
}
.v-input__prepend-outer{
  display: none;
}
</style>
